export default "__VITE_ASSET__DuL_uNM9__"